import React, { useState } from 'react';
import { FaTimes, FaChevronDown, FaPhone, FaEnvelope, FaGlobe, FaFacebook, FaTwitter, FaGoogle, FaLinkedin } from 'react-icons/fa';

const Sidebar = ({ isOpen, onClose }) => {
  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleMenu = (menuKey) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  const menuItems = [
    {
      key: 'index',
      label: 'Index',
      items: [
        { label: 'Index 01', href: '/' },
        { label: 'Index 02', href: '/index-2' },
        { label: 'Index 03', href: '/index-3' },
        { label: 'Index 04', href: '/index-4' },
        { label: 'Index 05', href: '/index-5' },
        { label: 'Index 06', href: '/index-6' }
      ]
    },
    {
      key: 'listings',
      label: 'Listings',
      items: [
        {
          label: 'Listing Grid',
          submenu: [
            { label: 'Grid View 1', href: '/grid-view' },
            { label: 'Grid View 2', href: '/grid-view-2' },
            { label: 'Grid View 3', href: '/grid-view-3' }
          ]
        },
        {
          label: 'Listing List',
          submenu: [
            { label: 'List View 1', href: '/list-view' },
            { label: 'List View 2', href: '/list-view-2' },
            { label: 'List View 3', href: '/list-view-3' }
          ]
        }
      ]
    },
    {
      key: 'agents',
      label: 'Agents',
      items: [
        { label: 'Agent Grid 1', href: '/agent-grid' },
        { label: 'Agent Grid 2', href: '/agent-grid-2' },
        { label: 'Agent List 1', href: '/agent-list' },
        { label: 'Agent Details', href: '/agent-detail' }
      ]
    },
    {
      key: 'pages',
      label: 'Pages',
      items: [
        { label: 'About 1', href: '/about' },
        { label: 'About 2', href: '/about-2' },
        { label: 'Services 1', href: '/services' },
        { label: 'Services 2', href: '/services-2' },
        { label: 'My Profile', href: '/my-profile' },
        { label: 'My Property', href: '/my-property' },
        { label: 'Submit Property', href: '/submit-property' },
        { label: 'Login', href: '/login' },
        { label: 'Register', href: '/register' }
      ]
    },
    {
      key: 'blog',
      label: 'Blog',
      items: [
        { label: 'Blog Grid', href: '/blog' },
        { label: 'Blog List', href: '/blog-list' },
        { label: 'Blog Details', href: '/blog-detail' }
      ]
    },
    {
      key: 'contact',
      label: 'Contact',
      items: [
        { label: 'Contact 1', href: '/contact' },
        { label: 'Contact 2', href: '/contact-2' },
        { label: 'Contact 3', href: '/contact-3' }
      ]
    }
  ];

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <nav
        className={`fixed top-0 right-0 h-full w-80 bg-white shadow-2xl transform transition-transform duration-300 z-50 lg:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Close Button */}
        <div className="flex justify-end p-4">
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors"
          >
            <FaTimes className="w-6 h-6 text-gray-600" />
          </button>
        </div>

        {/* Sidebar Content */}
        <div className="px-6 pb-6 h-full overflow-y-auto">
          {/* Logo */}
          <div className="mb-8">
            <img src="/img/logos/logo.png" alt="Logo" className="h-12" />
          </div>

          {/* Navigation Menu */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Pages</h3>
            <ul className="space-y-2">
              {menuItems.map((menu) => (
                <li key={menu.key}>
                  <button
                    onClick={() => toggleMenu(menu.key)}
                    className="flex items-center justify-between w-full py-2 text-left text-gray-700 hover:text-blue-600 transition-colors"
                  >
                    {menu.label}
                    <FaChevronDown
                      className={`w-4 h-4 transition-transform ${
                        expandedMenus[menu.key] ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {expandedMenus[menu.key] && (
                    <ul className="ml-4 mt-2 space-y-1">
                      {menu.items.map((item, index) => (
                        <li key={index}>
                          {item.submenu ? (
                            <div>
                              <span className="block py-1 text-gray-600 font-medium">
                                {item.label}
                              </span>
                              <ul className="ml-4 space-y-1">
                                {item.submenu.map((subItem, subIndex) => (
                                  <li key={subIndex}>
                                    <a
                                      href={subItem.href}
                                      className="block py-1 text-gray-600 hover:text-blue-600 transition-colors"
                                    >
                                      {subItem.label}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ) : (
                            <a
                              href={item.href}
                              className="block py-1 text-gray-600 hover:text-blue-600 transition-colors"
                            >
                              {item.label}
                            </a>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Get in Touch</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <FaPhone className="w-4 h-4 text-blue-600 mr-3" />
                <a href="tel:0477-8556-552" className="text-gray-600 hover:text-blue-600">
                  0477 8556 552
                </a>
              </div>
              <div className="flex items-center">
                <FaEnvelope className="w-4 h-4 text-blue-600 mr-3" />
                <a href="mailto:info@themevessel.com" className="text-gray-600 hover:text-blue-600">
                  info@themevessel.com
                </a>
              </div>
              <div className="flex items-center">
                <FaGlobe className="w-4 h-4 text-blue-600 mr-3" />
                <a href="#" className="text-gray-600 hover:text-blue-600">
                  www.themevessel.com
                </a>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Get Social</h3>
            <div className="flex space-x-3">
              <a
                href="#"
                className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
              >
                <FaFacebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-blue-400 text-white rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors"
              >
                <FaTwitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors"
              >
                <FaGoogle className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-blue-700 text-white rounded-full flex items-center justify-center hover:bg-blue-800 transition-colors"
              >
                <FaLinkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
